import { ActionIcon, Stack, Text, Tooltip } from "@mantine/core";
import { IconLine, IconLink } from "@tabler/icons-react";
import { useFlowStore } from "../../../../../../../stores/WorkflowStore";
import { useLanguage } from "../../../../../../../stores/LanguageStore";

const Linker = ({ id, xPos, yPos, type }) => {
  const lang = useLanguage((s) => s.language);
  const setLinking = useFlowStore((s) => s.setLinking);

  const handleClick = () => {
    setLinking({ xPos, yPos, id, type });
  };

  return (
    <Tooltip label={lang.workflows.linker_text}>
      <ActionIcon
        size={25}
        onClick={handleClick}
        pos={"absolute"}
        top={"102%"}
        right={32}
        radius={"sm"}
        variant="light"
        className="node-plus branch"
      >
        <IconLink size={18} />
      </ActionIcon>
    </Tooltip>
  );
};

export default Linker;
